import { useCallback, useEffect, useState } from "react";
import { useContextSite } from "../../../context/Context";
import { toast } from "react-toastify";
import { useSearchParams } from "react-router-dom";
import { Questionario } from "../../../services/Questionario";
import {
  IPerguntaDTO,
  IQuestionarioRespostaForm,
} from "../../../types/questionario";

const ICONS = [
  {
    icon: "/assets/svgs/icon-ruim.svg",
    label: "Ruim",
    value: 1,
  },
  {
    icon: "/assets/svgs/icon-regular.svg",
    label: "Regular",
    value: 2,
  },
  {
    icon: "/assets/svgs/icon-bom.svg",
    label: "Bom",
    value: 3,
  },
  {
    icon: "/assets/svgs/icon-excelente.svg",
    label: "Excelente",
    value: 4,
  },
];

export const useSatisfactionSurvey = () => {
  const [answered, setAnswered] = useState(false);
  const { setIsLoad } = useContextSite();
  const [searchParams] = useSearchParams();
  const uuidQuestionario = searchParams.get("idQuestionario");
  const [form, setForm] = useState<IQuestionarioRespostaForm>({
    respostas: [],
    uuidQuestionario,
  } as IQuestionarioRespostaForm);
  const [questions, setQuestions] = useState<IPerguntaDTO[]>(
    [] as IPerguntaDTO[]
  );

  const getFormulario = useCallback(() => {
    setIsLoad(true);
    Questionario.getById({ uuidQuestionario })
      .then(({ data }) => {
        setQuestions(data.perguntas);
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => {
          toast.error(mensagem);
        }
      )
      .finally(() => setIsLoad(false));
  }, []);

  function submitForm(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setIsLoad(true);

    Questionario.responder(form)
      .then(() => {
        setAnswered(true);
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => {
          toast.error(mensagem);
        }
      )
      .finally(() => setIsLoad(false));
  }

  useEffect(() => {
    if (uuidQuestionario) {
      getFormulario();
    }
  }, [uuidQuestionario]);

  return {
    ICONS,
    answered,
    submitForm,
    setForm,
    form,
    questions,
  };
};
